var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"call-details-blocks files-preview"},[_c('div',{staticClass:"block"},_vm._l((_vm.files),function(file){return _c('div',{key:file.fileUrl,staticClass:"file"},[_c('file-preview',{attrs:{"file":file}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }